import React from "react";

import "../assets/styles/watchingStyles.css";

const PokeWatching = () => {
  return (
    <div className="watching-section">
      <div className="watching-container">
        <div className="weepinbell-container"></div>
        <div className="koffing-container"></div>
      </div>
    </div>
  );
};

export default PokeWatching;
